import { useEffect, useState } from 'react';

const STORAGE_KEY = 'pl_active_profile';
const EVENT_NAME = 'pl:active-profile-change';

export function getActiveProfileId(): string | null {
  if (typeof window === 'undefined') return null;
  const v = window.localStorage.getItem(STORAGE_KEY);
  return v && v.length > 0 ? v : null;
}

export function setActiveProfileId(id: string | null): void {
  if (typeof window === 'undefined') return;
  if (id) window.localStorage.setItem(STORAGE_KEY, id);
  else window.localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { id } }));
}

export function useActiveProfileId(): [string | null, (id: string | null) => void] {
  const [id, setId] = useState<string | null>(() => getActiveProfileId());
  useEffect(() => {
    const onChange = (): void => setId(getActiveProfileId());
    window.addEventListener(EVENT_NAME, onChange);
    window.addEventListener('storage', onChange);
    return () => {
      window.removeEventListener(EVENT_NAME, onChange);
      window.removeEventListener('storage', onChange);
    };
  }, []);
  return [id, setActiveProfileId];
}
